import { render, staticRenderFns } from "./ResponsiveOrientation.vue?vue&type=template&id=c3e50908"
import script from "./ResponsiveOrientation.vue?vue&type=script&lang=js"
export * from "./ResponsiveOrientation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports